<template>
    <CardBase title="Resumen" :loading="loading">
        <template #extra-data>
            <DateRangePicker @change="onDateRangeChange" />
        </template>

        <b-row class="m-3">
            <b-col cols="12" md="6">
                <b-row class="justify-content-center">
                    <b-col cols="4" md="3" class="p-0">
                        <div class="chart-container">
                            <GChart
                                type="PieChart"
                                :data="datosTotal"
                                :options="opcionesChart('Total Enviados', 'success')"
                            />
                            <div class="chart-center-text" style="color: #0a7550;">{{ getPorcentaje(resumen.enviados) }}%</div>
                        </div>
                        <div class="chart-total-text">
                            <div class="total-amount">{{ resumen.enviados }}</div>
                            <div class="chart-title">Emails Enviados</div>
                        </div>
                    </b-col>
        
                    <b-col cols="4" md="3" class="p-0">
                        <div class="chart-container">
                            <GChart
                                type="PieChart"
                                :data="datosEntregados"
                                :options="opcionesChart('Entregados', 'light')"
                            />
                            <div class="chart-center-text" style="color: #41aa2f;">{{ getPorcentaje(resumen.entregados) }}%</div>
                        </div>
                        <div class="chart-total-text">
                            <div class="total-amount">{{ resumen.entregados }}</div>
                            <div class="chart-title">Emails Entregados</div>
                        </div>
                    </b-col>
        
                    <b-col cols="4" md="3" class="p-0">
                        <div class="chart-container">
                            <GChart
                                type="PieChart"
                                :data="datosRebotados"
                                :options="opcionesChart('Rebotados', 'warning')"
                            />
                            <div class="chart-center-text" style="color: #f65903;">{{ getPorcentaje(resumen.rebotados) }}%</div>
                        </div>
                        <div class="chart-total-text">
                            <div class="total-amount">{{ resumen.rebotados }}</div>
                            <div class="chart-title">Emails Rebotados</div>
                        </div>
                    </b-col>
        
                    <b-col cols="4" md="3" class="p-0">
                        <div class="chart-container">
                            <GChart
                                type="PieChart"
                                :data="datosSpam"
                                :options="opcionesChart('Spam', 'danger')"
                            />
                            <div class="chart-center-text" style="color: #da3343;">{{ getPorcentaje(resumen.spam) }}%</div>
                        </div>
                        <div class="chart-total-text">
                            <div class="total-amount">{{ resumen.spam }}</div>
                            <div class="chart-title">Emails Spam</div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="6" class="mt-3 mt-md-0">
                <b-row>
                    <b-col cols="12" md="6" class="p-0 pr-md-2 mb-2 mb-md-0">
                        <div class="bar-box">
                            <b-progress
                                :value="resumen.abiertos"
                                :max="resumen.enviados"
                                height="20px"
                                variant="warning"
                                animated
                                striped
                            />
                            <div class="bar-chart-info">
                                <span class="bar-value">
                                    {{ resumen.abiertos_unicos }}
                                    <small style="font-size: 0.75rem; color: #999;">
                                        {{ getPorcentaje(resumen.abiertos_unicos, resumen.entregados) }}%
                                    </small>
                                </span>
                                <div class="bar-label">Emails visualizados</div>
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6" class="p-0 pr-md-2 mb-2 mb-md-0">
                        <div class="bar-box">
                            <b-progress
                                :value="resumen.clickados"
                                :max="resumen.enviados"
                                height="20px"
                                variant="primary"
                                animated
                                striped
                            />
                            <div class="bar-chart-info">
                                <span class="bar-value">
                                    {{ resumen.clickados_unicos }}
                                    <small style="font-size: 0.75rem; color: #999;">
                                        {{ getPorcentaje(resumen.clickados_unicos, resumen.entregados) }}%
                                    </small>
                                </span>
                                <div class="bar-label">Emails clickados</div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-2">
                        <div class="d-flex justify-content-between align-items-center border-bottom py-2">
                            <span>
                                Visualizaciones totales
                                <InfoToolTip info="Este es el número total de aperturas. Si un subscriptor abre un mensaje varias veces, se mostrará aquí." />
                            </span>
                            <strong>{{ resumen.abiertos }}</strong>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-bottom py-2">
                            <span>
                                Clics totales
                                <InfoToolTip info="Este es el número total de clics. Si un subscriptor hace click en varios enlaces en el mimso mensaje, se aquí." />
                            </span>
                            <strong>{{ resumen.clickados }}</strong>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-2">
                        <div class="d-flex justify-content-between align-items-center border-bottom py-2" v-if="resumen.subscriptor_nuevos ">
                            <span>
                                Nuevos suscriptores
                                <InfoToolTip info="Indice el número de personas que se suscribieron usando sus formularios de registro." />
                            </span>
                            <strong>{{ resumen.subscriptor_nuevos }}</strong>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-bottom py-2">
                            <span>
                                Informes de spam
                                <InfoToolTip info="Indice el número de personas que marcaron tus mensajes como spam." />
                            </span>
                            <strong>{{ resumen.spam }}</strong>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </CardBase>
</template>

<script>
    import InfoToolTip from '@/components/common/InfoToolTip';
    import CardBase from './common/CardBase';
    import DateRangePicker from './common/DateRangePicker';

    export default {
        props: {
            datosResumen: {
                type: Object,
                default: () => ({})
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: false,
                resumen: {
                    enviados: 0,
                    entregados: 0,
                    rebotados: 0,
                    spam: 0,
                    abiertos: 0,
                    abiertos_unicos: 0,
                    clickados: 0,
                    clickados_unicos: 0,
                    subscriptor_nuevos: 0,
                    total: 0
                },
                datosTotal: [["Estado", "Cantidad"]],
                datosEntregados: [["Estado", "Cantidad"]],
                datosRebotados: [["Estado", "Cantidad"]],
                datosSpam: [["Estado", "Cantidad"]]
            };
        },
        methods: {
            generarDatos() {
                const ocultarDato = 0.0000000000000001;
                const entregados = this.resumen.entregados ?? ocultarDato;
                const rebotados = this.resumen.rebotados ?? ocultarDato;
                const spam = this.resumen.spam ?? ocultarDato;
                const total = entregados + rebotados + spam;

                this.resumen.total = total;

                this.datosTotal = [
                    ["Estado", "Cantidad"],
                    ["Total Enviados", total],
                    ["", ocultarDato]
                ];
                this.datosEntregados = [
                    ["Estado", "Cantidad"],
                    ["Entregados", entregados],
                    ["", total > 0 ? total - entregados : ocultarDato]
                ];
                this.datosRebotados = [
                    ["Estado", "Cantidad"],
                    ["Rebotados", rebotados],
                    ["", total > 0 ? total - rebotados : ocultarDato]
                ];
                this.datosSpam = [
                    ["Estado", "Cantidad"],
                    ["Spam", spam],
                    ["", entregados > 0 ? entregados - spam : ocultarDato]
                ];
            },
            opcionesChart(title, colorClass) {
                let color;
                switch (colorClass) {
                    case 'success':
                        color = '#0a7550';
                        break;
                    case 'light':
                        color = '#41aa2f';
                        break;
                    case 'warning':
                        color = '#f65903';
                        break;
                    case 'danger':
                        color = '#da3343';
                        break;
                    default:
                        color = '#4285F4';
                        break;
                }

                const isMobile = window.innerWidth <= 1024;

                return {
                    height: 100,
                    width: isMobile ? 80 : 100,
                    chartArea: { width: '100%', height: '100%' },
                    pieHole: 0.8,
                    legend: 'none',
                    tooltip: { trigger: 'none' },
                    backgroundColor: 'transparent',
                    colors: [color, '#E0E0E0']
                };
            },
            getPorcentaje(valor, base = this.resumen.total) {
                const total = base;
                if (total === 0) return 0;
                return (valor / total * 100).toFixed(2);
            },

            onDateRangeChange(dateRange){
                this.$emit('date-range-changed', dateRange);
            }
        },
        watch: {
            datosResumen: {
                handler(newData){
                    if(Object.keys(newData).length > 0){
                        this.resumen = { ...newData };
                        this.generarDatos();
                    }
                },
                deep: true,
                immediate: true
            },

            isLoading(val) {
                this.loading = val;
            }
        },
        components: {
            CardBase,
            InfoToolTip,
            DateRangePicker
        }
    };
</script>

<style>
.custom-dropdown-menu {
    min-width: 300px !important;
    max-width: 100% !important;
    width: 400px !important;
}
.chart-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 0 auto;
    left: 0;
}
@media (max-width: 1024px) {
    .chart-container {
        width: 80px;
        height: 80px;
        left: 0px;
    }

    .chart-center-text {
        font-size: 12px;
        top: 63% !important;
        left: 50% !important;
    }

    .total-amount {
        font-size: 14px;
    }

    .chart-title {
        font-size: 11px;
    }
}
.chart-center-text {
    position: absolute;
    top: 52%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    font-weight: bold;
}

.chart-total-text {
    text-align: center;
    margin-top: 10px;
}

.total-amount {
    font-size: 16px;
    font-weight: bold;
}

.chart-title {
    font-size: 12px;
    color: #666;
}
.bar-box {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
    width: 100%;
    border-radius: 5px;
}
.bar-chart-info {
    font-size: 14px;
    color: #f65903;
}
.bar-value {
    font-weight: bold;
    font-size: 20px;
    margin-right: 5px;
}
.bar-percentage {
    font-size: 14px;
    color: #888;
}
.bar-label {
    margin-top: 4px;
    font-size: 13px;
    color: #666;
}.metricas-listado {
    margin-top: 1rem;
}
.metrica-item {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #e0e0e0;
    font-size: 14px;
    color: #333;
}
.metrica-label {
    font-weight: 500;
}
.metrica-valor {
    font-weight: 600;
}
</style>